module.exports = __webpack_public_path__ + "static/media/cancer.efb9d5a3.svg";